let controller1 = new ScrollMagic.Controller();

//secton31
var box31_title=document.getElementsByClassName('box31_title');
let scene31 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox3_1', 
        triggerHook: "onenter",
        duration:0,
})
scene31.on("progress", function (event) {
    box31_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box31_title[0].classList.remove("showup");
    }
})

//secton4
var box4_title=document.getElementsByClassName('box4_title');
var box4_text=document.getElementsByClassName('box4_text');
let scene4 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox4', 
        triggerHook: "onenter",
        duration:0,
})
scene4.on("progress", function (event) {
    box4_title[0].classList.add("showup");
    box4_text[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box4_title[0].classList.remove("showup");
        box4_text[0].classList.remove("showup");
    }
})

//secton5
var box5_title=document.getElementsByClassName('box5_title');
var box5_text=document.getElementsByClassName('box5_text');
var box5_item=document.getElementsByClassName('box5_item');
let scene5 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox5', 
        triggerHook: "onenter",
        duration:0,
})
scene5.on("progress", function (event) {
    box5_title[0].classList.add("showup");
    box5_text[0].classList.add("showup");
    box5_item[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box5_title[0].classList.remove("showup");
        box5_text[0].classList.remove("showup");
        box5_item[0].classList.remove("showup");
    }
})

//secton6
var box6_title=document.getElementsByClassName('box6_title');
var box6_item=document.getElementsByClassName('box6_item');
let scene6 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox6', 
        triggerHook: "onenter",
        duration:0,
})
scene6.on("progress", function (event) {
    box6_title[0].classList.add("showup");
    box6_item[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box6_title[0].classList.remove("showup");
        box6_item[0].classList.remove("showup");
    }
})

//secton7
var box7_title=document.getElementsByClassName('box7_title');
var box7_text=document.getElementsByClassName('box7_text');
var box7_play=document.getElementsByClassName('box7_play');
var box7_info=document.getElementsByClassName('box7_info');
let scene7 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox7', 
        triggerHook: "onenter",
        duration:0,
})
scene7.on("progress", function (event) {
    box7_title[0].classList.add("showup");
    box7_text[0].classList.add("showup");
    box7_play[0].classList.add("showup");
    box7_info[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box7_title[0].classList.remove("showup");
        box7_text[0].classList.remove("showup");
        box7_play[0].classList.remove("showup");
        box7_info[0].classList.remove("showup");
    }
})

//secton8
var box8_title=document.getElementsByClassName('box8_title');
let scene8 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox8', 
        triggerHook: "onenter",
        duration:0,
})
scene8.on("progress", function (event) {
    box8_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box8_title[0].classList.remove("showup");
    }
})

//secton9
var box9_title=document.getElementsByClassName('box9_title');
let scene9 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox9',
        triggerHook: "onenter",
        duration:0,
})
scene9.on("progress", function (event) {
    box9_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){ 
        box9_title[0].classList.remove("showup");
    }
})
let scene9_1 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox9',
        triggerHook: "0",
        duration:1000,
        reverse:true
})
scene9_1.setPin('.Obox9');


var i_oneo = 0;
var flag_oneo;
function startOneo(){
    flag_oneo =  setInterval(oil,100)
}
startOneo()
function oil(){
    i_oneo++;
    $('.box9_products').hide()
    $(`.box9_move .box9_products:nth-child(${i_oneo})`).show()
    if(i_oneo == 22){
        i_oneo=0;
    }
}


scene9_1.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    if(index1<30){
        $('.box9_product').css({width:'100%',marginLeft:'0%',marginTop:'0%',maxWidth:'100%'})
        $('.box9_move').hide()
    }
    if(index1>40){
        if(index1>80){
            $('.box9_move').show()
        }else{
            $('.box9_move').hide()
        }
        $('.box9_product').css({width:'150%',marginLeft:'-25%',marginTop:'-11.8%',maxWidth:'200%'})
    }
})
var box9_title=document.getElementsByClassName('box9_title');
let scene9_2 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox9_1',
        triggerHook: "onenter",
        duration:0,
})
scene9_2.on("progress", function (event) {
    box9_title[1].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){ 
        box9_title[1].classList.remove("showup");
    }
})

controller1.addScene([scene31,scene4,scene5,scene6,scene7,scene8,scene9,scene9_1,scene9_2]); 

$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-oneo-pod-kit'); 
})

$('.box7_play').click(function(){
    if(window.innerWidth<750){
        var element = $('.box7_video')[0]
        if(element.requestFullscreen){
            element.requestFullscreen()
        }
    }
    $('.box7_video').show()
    $('.box7_close').show()
    $('.box7_video')[0].currentTime = 0;
    $('.box7_video')[0].play()
})
$('.box7_close').click(function(){
    $('.box7_video').hide()
    $(this).hide()
})

var SwiperFlag = 1

//section32
$('.box32_icon').click(function(){
    var index = $(this).parent().index()+1
    SwiperFlag = index;
    box32Swiper(index)
})

function box32Swiper(index){
     //img
     $('.bt32_img').hide()
     $(`.bt32_img${index}`).show()
     $('.br32_img').hide()
     $(`.br32_img${index}`).show()
     //title
     $('.colorName').hide()
     $(`.colorName${index}`).show()
     //icon
     $('.box32_icon').show()
     $('.box32_iconActive').hide()
     $(`.box32_cItems .box32_icons:nth-child(${index}) .box32_icon`).hide()
     $(`.box32_cItems .box32_icons:nth-child(${index}) .box32_iconActive`).show()
}

let isDragging = false;
let startPositionX = 0;
let endPositionX = 0;

const dragElement = document.getElementById('dragElement');

dragElement.addEventListener('touchstart', (event) => {
  isDragging = true;
  startPositionX = event.touches[0].clientX;
});

dragElement.addEventListener('touchmove', (event) => {
  if (isDragging) {
    endPositionX = event.touches[0].clientX;
    event.preventDefault(); // 防止滚动
  }
});

dragElement.addEventListener('touchend', () => {
  if (isDragging) {
    isDragging = false;
    const deltaX = endPositionX - startPositionX;

    if (deltaX > 0) {
        if(SwiperFlag>1){
            SwiperFlag--;
            box32Swiper(SwiperFlag)
          }
      
    } else if (deltaX < 0) {
        if(SwiperFlag<10){
            SwiperFlag++;
            box32Swiper(SwiperFlag)
        }
    }
  }
});

$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})